import styled from 'styled-components';

import Select from '../common/Select';
import { Button as CommonButton } from 'Shared/Button';
import { mediaBreakpointDown } from 'Shared/Utility';

export const Panel = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 15px #ddd;
  margin: 30px 0;
  padding: 40px 30px;
  ${mediaBreakpointDown('sm')} {
    padding: 25px 15px;
  }
`;

export const PanelAction = styled.div`
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const PanelActionLeftContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  width: calc(100% - 150px);
  flex: 1 0 100%;
`;

export const PanelActionRightContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  flex: 1 0 100%;
  margin: 0;
  justify-content: flex-end;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-left: 53px;
  > * {
    margin-left: 7px;
  }
`;

export const PanelActionIconContainer = styled.div`
  min-width: 36px;
  max-width: 36px;
  margin-right: 17px;
  display: flex;
  justify-content: center;

  > img {
    width: 20px;
    height: 20px;
  }
`;

export const PanelActionCrossTabSelect = styled(Select)`
  max-width: 350px;
  min-width: 300px;
  ${mediaBreakpointDown('xs')} {
    max-width: 100%;
    width: 100%;
    min-width: auto;
  }
`;

export const Button = styled(CommonButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #aaaaaa;
  > img {
    width: 15px;
    height: 15px;
  }
  ${(props) =>
    props.active &&
    `
    background-color:rgb(51, 102, 153);
  `}
`;

export const ButtonGroup = styled.div`
  display: flex;
  > ${Button}:nth-child(1) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  > ${Button}:nth-child(2) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

export const PanelBody = styled.div`
  margin-top: 25px;
`;

export const DisqualifierPanel = styled.div`
  background: #ddf4dd;
  padding: 20px 20px;
  margin: 40px -30px -40px -30px;
  font-weight: 400;
  text-align: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: 1px solid #cdc;
  ${mediaBreakpointDown('sm')} {
    margin: 25px -15px -25px -15px;
  }
`;

export const TableContainer = styled.div`
  max-height: 400px;
  overflow: scroll;
  border-top: 1px solid #ccc;
`;

export const Table = styled.table`
  width: 100%;
  background: #eee;
  border-spacing: 0;

  thead {
    td {
      font-weight: 400;
    }
  }
  td {
    padding: 6px;
    border-bottom: 1px solid #ccc;
    text-align: left;
  }
`;

export const ImageChoiceList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 30px;
`;

export const ImageChoiceItem = styled.div`
  margin-right: 15px;
  > img {
    max-width: 200px;
    max-height: 200px;
    cursor: zoom-in;
  }
  > p {
    text-align: center;
  }
`;

export const ZoomImage = styled.img`
  max-width: 800px;
  width: 100%;
`;

export const ChartContainer = styled.div`
  padding: 25px 0 0 0;
`;
